// Dashboard "活躍設備 / 在線" card. The API (GET /api/account/dashboard) counts
// ACTIVE deviceops devices at the account's venues; onlineDevices is the subset
// seen in the last 5 minutes. A missing or non-numeric value means the counts
// are unavailable (e.g. 503 DASHBOARD_UNAVAILABLE) and must never render as 0.
export const UNAVAILABLE = "—";

function count(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

// A count the API does not define yet (e.g. totalInstalls: null) renders as "—".
export function formatCount(value) {
  const n = count(value);
  return n === null ? UNAVAILABLE : n;
}

// Money the API returns as null (estimatedCommission, unreadable balance) renders as "—".
export function formatMoney(value) {
  const n = count(value);
  return n === null ? UNAVAILABLE : `NT$${n}`;
}

export function formatDeviceStats(stats) {
  const active = count(stats?.activeDevices);
  const online = count(stats?.onlineDevices);
  if (active === null || online === null) {
    return { value: UNAVAILABLE, sub: "無法取得" };
  }
  return { value: active, sub: `${online} 在線` };
}
